// extracted by mini-css-extract-plugin
export default {"container":"Branch_container__ukSrd"};